<!--  Created by   : Namit Tiwari                                                             -->
<!--  Create Dated : 25-Nov-2021                                                              -->
<!--  Purpose      : For Ticket Booking                                                       -->
<template>
  <div id="mainDiv">
    <fieldset class="EntryBlock" v-if="bookingID == -1 && !isNewEdit">
      <legend>My Booking</legend>
      <div class="Flex_Table tblEntryForm">
        <div class="Flex_Row">
          <input
            type="button"
            id="btnNew"
            name="btnNew"
            btnName="btnNew"
            value="New Booking"
            title="Click to Add New Booking"
            style="margin: 0px; padding: 5px 15px; font-size: medium"
            v-on:click="newBookingClick()"
          />
        </div>
        <div class="Flex_Row">
          <div class="Flex_Table ekkGrid" style="border-radius: 6px">
            <div class="Flex_Row GridHeader" valign="middle">
              <div class="Flex_Cell" align="center" valign="middle" style="width: 20%">Slot Details</div>
              <div class="Flex_Cell" align="center" valign="middle" style="width: 20%">Booking Date</div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width: 10%"
              >No. of Individuals</div>
              <div class="Flex_Cell" align="center" valign="middle" style="width: 10%">Total Amount</div>
              <div class="Flex_Cell" align="center" valign="middle" style="width: 20%">Ticket No.</div>
              <!-- <div class="Flex_Cell" align="center" valign="middle" style="width:10%;" > QRCode </div> -->
              <div class="Flex_Cell" align="center" valign="middle" style="width: 20%">--</div>
            </div>
            <div class="GridContent">
              <div class="Flex_Row" v-for="bl in myBooking_List" :key="bl.bookingID">
                <div class="Flex_Cell" align="center" valign="middle" style="width: 20%">
                  <span>{{ bl.slotDetails }}</span>
                </div>
                <div class="Flex_Cell" align="center" valign="middle" style="width: 20%">
                  <span>{{ bl.bookingDates }}</span>
                </div>
                <div class="Flex_Cell" align="center" valign="middle" style="width: 10%">
                  <span>{{ bl.noOfIndividuals }}</span>
                </div>
                <div class="Flex_Cell" align="center" valign="middle" style="width: 10%">
                  <span>{{ bl.totalAmount }}/-</span>
                </div>
                <div class="Flex_Cell" align="center" valign="middle" style="width: 20%">
                  <span v-if="bl.ticketNo">{{ bl.ticketNo }}</span>
                  <span v-else>--</span>
                </div>
                <div class="Flex_Cell" align="center" valign="middle" style="width: 20%">
                  <input
                    type="button"
                    v-on:click="getMyBookingOnClick(bl)"
                    value="Booking Detail"
                    style="padding: 5px"
                    class="btn"
                    title="Click to Edit"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <input
        type="button"
        id="btnNew"
        name="btnNew"
        btnName="btnNew"
        value="New Booking"
        title="Click to Add New Booking"
        style="margin: 0px; padding: 5px 15px; font-size: medium"
        v-on:click="newBookingClick()"
      />
    </fieldset>
    <div v-if="isNewEdit">
      <div class="Flex_Table">
        <div class="Flex_Row">
          <div class="Flex_Cell" style="width: 85%" align="right">
            <span
              v-if="myBooking_List.length > 0 || isFirstTimeBookingSaved == 1"
              v-on:click="backToMyBoking()"
              class="radioSpan"
            >Back To My Booking</span>
          </div>
        </div>
        <div class="Flex_Row" align="center">
          <div class="Flex_Cell" style="width: 100%">
            <step-progress :steps="bookingStages"></step-progress>
          </div>
        </div>
      </div>
      <fieldset class="EntryBlock" v-if="tabID == 1">
        <legend>{{ currentTabName }}</legend>
        <div class="Flex_Table tblEntryForm">
          <div class="Flex_Row">
            <div class="Flex_Cell">
              <fieldset class="EntryBlock" v-if="bookingTypeID != -1">
                <legend>Seats Availability</legend>
                <slot-calendar
                  v-if="bookingTypeID != -1"
                  :bookingTypeID="bookingTypeID"
                  :Type="rbFilterQuota"
                  :eventBus="calbus"
                  :key="bookingTypeID"
                  @change="selectedDate"
                ></slot-calendar>
              </fieldset>
            </div>
            <div class="Flex_Cell">
              <fieldset class="EntryBlock">
                <legend>Booking Details</legend>
                <div class="Flex_Table tblEntryForm">
                  <div class="Flex_Row" v-if="userTypeID == 3 || userTypeID == 4">
                    <div class="Flex_Cell">
                      <input
                        type="radio"
                        name="rbFilterQuota"
                        id="rbNormal"
                        value="0"
                        :disabled="bookingID != -1"
                        v-model="rbFilterQuota"
                        v-on:click="changeFilters(0)"
                      />
                      <label for="rbNormal">General</label>
                      <input
                        type="radio"
                        name="rbFilterQuota"
                        id="rbQuota"
                        value="1"
                        :disabled="bookingID != -1"
                        v-model="rbFilterQuota"
                        v-on:click="changeFilters(1)"
                      />
                      <label for="rbQuota">Reserve Quota</label>
                    </div>
                  </div>
                  <div class="Flex_Row">
                    <div class="Flex_Cell" align="center">
                      <span class="mandatorySpan" :class="{ Required: true }">Booking Type</span>
                      <select
                        class="appDropBox"
                        v-model="bookingTypeID"
                        :disabled="bookingID != -1"
                        v-on:change="getSavedBookingData(-1)"
                      >
                        <!-- <option value="-1">---Select---</option> -->
                        <option v-for="b in bookingType_List" :key="b[0]" :value="b[0]">{{ b[1] }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="Flex_Row" v-if="bookingForUnit == 0">
                    <div class="Flex_Cell">
                      <span class="mandatorySpan" :class="{ Required: true }">Date</span>
                      <DateControl
                        :isRequired="true"
                        v-model="bookingDate"
                        :fromDate="minDate"
                        :toDate="maxDate"
                        :showDate="true"
                        title="Enter Booking Date"
                        disabled
                      ></DateControl>
                    </div>
                    <div class="Flex_Cell">
                      <span class="mandatorySpan" :class="{ Required: true }">Time Slot [Seat left]</span>
                      <select
                        class="appDropBox"
                        v-model="timeSlotID"
                        v-on:change="getSeatLeftForSlot()"
                        :disabled="isTicketGenerated == 1"
                      >
                        <option value="-1">---Select---</option>
                        <option
                          v-for="b in availableSlot_List"
                          :key="b[0]"
                          :value="b[0]"
                        >{{ b[1] }} [ {{ b[2] }} ]</option>
                      </select>
                      <span
                        style="font-weight: bold; font-size: medium"
                        align="right"
                        v-if="timeSlotID != -1"
                      >
                        {{
                        seatLeftForSlot }} : Seat Left
                      </span>
                    </div>
                    <!-- <div class="Flex_Cell" valign="bottom"></div> -->
                  </div>
                  <div class="Flex_Row" v-if="bookingForUnit == 1">
                    <div class="Flex_Cell">
                      <span class="mandatorySpan" :class="{ Required: true }">Date</span>
                      <span
                        class="mandatorySpan"
                        style="display: none"
                        :class="{ Required: true }"
                      >From Date</span>
                      <!-- <input type="date" v-model="bookingFromDate"  style="display:inline-block" /> -->
                      <DateControl
                        :isRequired="true"
                        v-model="bookingFromDate"
                        :fromDate="minDate"
                        :toDate="maxDate"
                        :showDate="true"
                        title="Enter From Date"
                        disabled
                      ></DateControl>
                    </div>
                    <div class="Flex_Cell">
                      <span
                        class="mandatorySpan"
                        style="display: none"
                        :class="{ Required: true }"
                      >To Date</span>
                      <span class="mandatorySpan" :class="{ Required: true }">Time Slot [Seat left]</span>
                      <!-- <input type="date" v-model="bookingToDate"  style="display:inline-block" /> -->
                      <DateControl
                        style="display: none"
                        :isRequired="true"
                        v-model="bookingToDate"
                        :fromDate="minDate"
                        :toDate="maxDate"
                        :showDate="true"
                        title="Enter To Date"
                        disabled
                      ></DateControl>
                      <select
                        class="appDropBox"
                        v-model="timeSlotID"
                        v-on:change="getSeatLeftForSlot()"
                        :disabled="isTicketGenerated == 1"
                      >
                        <option value="-1">---Select---</option>
                        <option
                          v-for="b in availableSlot_List"
                          :key="b[0]"
                          :value="b[0]"
                        >{{ b[1] }} [ {{ b[2] }} ]</option>
                      </select>
                      <span
                        style="font-weight: bold; font-size: medium"
                        align="right"
                        v-if="timeSlotID != -1"
                      >
                        {{
                        seatLeftForGroup }} : Group(s) Left
                      </span>
                    </div>
                    <div class="Flex_Cell" style="display: none" valign="bottom">
                      <span
                        style="font-weight: bold; font-size: medium"
                      >{{ seatLeftForGroup }} : Group(s) Left</span>
                    </div>
                  </div>
                  <div class="Flex_Row">
                    <div class="Flex_Cell" align="center">
                      <transition name="fade">
                        <div
                          class="Flex_Table ekkGrid"
                          style="border-radius: 6px; font-size: small"
                        >
                          <div class="Flex_Row GridHeader" style="overflow-wrap: anywhere">
                            <div class="Flex_Cell" width="20%">Person</div>
                            <div class="Flex_Cell" width="20%">
                              <span v-if="bookingForUnit == 0">Rate/Person</span>
                              <span v-else>Rate/Group</span>
                            </div>
                            <div class="Flex_Cell" width="20%">
                              <span v-if="bookingForUnit == 0">No. of Person</span>
                              <span v-else>No. of Group</span>
                            </div>
                            <div class="Flex_Cell" width="20%">Total Amount</div>
                          </div>
                          <div
                            class="Flex_Row"
                            v-for="p in calcAgeGroupList"
                            :key="p.personGroupID"
                          >
                            <div
                              class="Flex_Cell"
                              align="center"
                              width="20%"
                              valign="middle"
                            >{{ p.personGroupName }}</div>
                            <div
                              class="Flex_Cell"
                              align="center"
                              width="20%"
                              valign="middle"
                            >{{ p.amountInRs }}/-</div>
                            <div class="Flex_Cell" align="center" width="20%" valign="middle">
                              <div class="Flex_Table">
                                <div class="Flex_Row" align="center" valign="middle">
                                  <span
                                    class="IconbuttonMinus"
                                    style="cursor: pointer; padding: 0px 3px"
                                    id="btnMinus"
                                    v-if="isTicketGenerated == 0"
                                    name="btnAdd"
                                    btnName="btnMinus"
                                    title="Click to Dicrease Person"
                                  >
                                    <a
                                      title="click to select"
                                      id="prvMinus"
                                      style="cursor: pointer"
                                      class="glyphicons circle_minus"
                                      v-on:click="minusPerson(p)"
                                    ></a>
                                  </span>
                                  <AcceptInput
                                    :disabled="isTicketGenerated == 1"
                                    :isRequired="true"
                                    placeholder
                                    ref="txtNoOfPerson"
                                    v-model="p.noOfIndividuals"
                                    maxlength="2"
                                    regExp="([0-9])*"
                                    title="Enter Number of Person"
                                    style="width: 45px;text-align: center;font-size: medium;border-radius: 4px;"
                                  />
                                  <span
                                    disabled
                                    class="IconbuttonPlus"
                                    style="cursor: pointer; padding: 0px 3px"
                                    id="btnAdd"
                                    v-if="isTicketGenerated == 0"
                                    name="btnAdd"
                                    btnName="btnAdd"
                                    title="Click to Increase Person"
                                  >
                                    <a
                                      title="click to select"
                                      id="prvAdd"
                                      style="cursor: pointer"
                                      class="glyphicons circle_plus"
                                      v-on:click="addPerson(p)"
                                    ></a>
                                  </span>
                                </div>
                                <div
                                  class="Flex_Row"
                                  align="center"
                                  valign="middle"
                                  v-if="p.noOfUnits > 1"
                                >
                                  <span>(Group of {{ p.noOfUnits }} person)</span>
                                </div>
                              </div>
                            </div>
                            <div
                              class="Flex_Cell"
                              width="20%"
                              align="center"
                              valign="middle"
                            >{{ p.totalAmount }}/-</div>
                          </div>
                          <div class="Flex_Row" v-if="calcTaxRate.length > 0">
                            <div class="Flex_Cell" width="20%">Total</div>
                            <div class="Flex_Cell" width="20%"></div>
                            <div
                              class="Flex_Cell"
                              width="20%"
                              align="center"
                              valign="middle"
                            >{{ totalPerson }}</div>
                            <div class="Flex_Cell" width="20%">{{ totalAmount }}</div>
                          </div>
                          <div class="Flex_Row" v-for="t in calcTaxRate" :key="t.taxID">
                            <div class="Flex_Cell">{{ t.taxName }}</div>
                            <div class="Flex_Cell" style="width: 20%"></div>
                            <div
                              class="Flex_Cell"
                              style="width: 30%"
                              align="center"
                              valign="middle"
                            >
                              <span v-if="t.taxID != 3">{{ t.taxRate }} %</span>
                            </div>
                            <div class="Flex_Cell" style="width: 20%" align="right">
                              <span v-if="t.taxID != 3">{{ t.taxAmount }}</span>
                              <AcceptInput
                                :disabled="isTicketGenerated == 1"
                                v-if="t.taxID == 3"
                                :isRequired="true"
                                placeholder
                                ref="txtOtherTax"
                                v-model="t.taxAmount"
                                maxlength="5"
                                regExp="([0-9])*"
                                title="Enter Other Tax"
                                style="text-align: right;font-size: medium;border-radius: 4px;"
                              />
                            </div>
                          </div>
                          <div class="Flex_Row" v-if="isPromoCodeRequired == 1">
                            <div class="Flex_Cell" width="20%">Any Promo Code</div>
                            <div class="Flex_Cell" width="20%"></div>
                            <div class="Flex_Cell" width="20%">
                              <AcceptInput
                                :disabled="isTicketGenerated == 1"
                                :isRequired="true"
                                placeholder
                                ref="txtOtherTax"
                                v-model="promoCode"
                                maxlength="10"
                                title="Enter Promocode"
                                style="text-align: center;font-size: medium;border-radius: 4px;"
                              />
                            </div>
                            <div class="Flex_Cell" width="20%" align="right">
                              <AcceptInput
                                :disabled="isTicketGenerated == 1"
                                :isRequired="true"
                                placeholder
                                ref="txtOtherTax"
                                v-model="discountAmount"
                                maxlength="5"
                                regExp="([0-9])*"
                                title="Enter Other Tax"
                                style="text-align: right;font-size: medium;border-radius: 4px;"
                              />
                            </div>
                          </div>
                          <div class="Flex_Row GridHeader">
                            <div class="Flex_Cell" width="20%">Total Payable</div>
                            <div class="Flex_Cell" width="20%"></div>
                            <div class="Flex_Cell" width="20%">{{ totalPerson }}</div>
                            <div
                              class="Flex_Cell"
                              width="20%"
                              align="right"
                            >{{ finalTotalAmount }}/-</div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>

            <div class="Flex_Cell" v-if="isVisitorDataRequired == 0">
              <fieldset class="EntryBlock visitorField">
                <legend>Visitor Details</legend>
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <div class="Flex_Cell">
                      <span class="mandatorySpan" :class="{ Required: true }">First Name</span>
                      <AcceptInput
                        :isRequired="true"
                        placeholder="First Name"
                        ref="txtFirstName"
                        v-model="visitor_Param.FirstName"
                        maxlength="256"
                        regExp="([a-zA-Z\s])*"
                        title="Enter first name"
                      />
                    </div>
                  </div>
                  <div class="Flex_Row">
                    <div class="Flex_Cell">
                      <span class="mandatorySpan" :class="{ Required: false }">Middle Name</span>
                      <AcceptInput
                        :isRequired="false"
                        placeholder="Middle Name"
                        ref="txtMiddleName"
                        v-model="visitor_Param.MiddleName"
                        maxlength="256"
                        regExp="([a-zA-Z\s])*"
                        title="Enter Middle Name"
                      />
                    </div>
                  </div>
                  <div class="Flex_Row">
                    <div class="Flex_Cell">
                      <span class="mandatorySpan" :class="{ Required: true }">Last Name</span>
                      <AcceptInput
                        :isRequired="true"
                        placeholder="Last Name"
                        ref="txtLastName"
                        v-model="visitor_Param.LastName"
                        maxlength="256"
                        regExp="([a-zA-Z\s])*"
                        title="Enter Last Name"
                      />
                    </div>
                  </div>
                  <div class="Flex_Row">
                    <div class="Flex_Cell">
                      <span class="mandatorySpan" :class="{ Required: true }">Date of Birth</span>
                      <DateControl
                        :isRequired="true"
                        v-model="visitor_Param.DOB"
                        :toDate="new Date()"
                        title="Enter Date of birth"
                      ></DateControl>
                    </div>
                  </div>
                  <div class="Flex_Row">
                    <div class="Flex_Cell">
                      <span class="mandatorySpan" :class="{ Required: true }">Gender</span>
                      <span v-for="(g, index) in gender_List" :key="g[0]">
                        <input
                          type="radio"
                          name="rblGender"
                          v-model="visitor_Param.GenderID"
                          :value="g[0]"
                          :id="'gender_' + index"
                        />
                        <label :for="'gender_' + index">{{ g[1] }}</label>
                      </span>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div class="Flex_Row" v-if="isTicketGenerated == 0">
            <div class="Flex_Cell" align="right">
              <input
                type="button"
                id="btnSave"
                name="btnSave"
                btnName="btnSave"
                value="Save Booking"
                title="Click to Save detail"
                style="margin: 0px; padding: 5px 15px; font-size: medium"
                v-on:click="saveBooking()"
              />
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset class="EntryBlock" v-if="tabID == 2">
        <legend>{{ currentTabName }}</legend>
        <div class="Flex_Table tblEntryForm">
          <div class="Flex_Row">
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: true }">Title</span>
              <select id="ddlTitle" v-model="visitor_Param.TitleID">
                <option value="-1">---Select---</option>
                <option v-for="t in title_List" :key="t[0]" v-bind:value="t[0]">{{ t[1] }}</option>
              </select>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: true }">First Name</span>
              <AcceptInput
                :isRequired="true"
                placeholder="First Name"
                ref="txtFirstName"
                v-model="visitor_Param.FirstName"
                maxlength="256"
                regExp="([a-zA-Z\s])*"
                title="Enter first name"
              />
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: false }">Middle Name</span>
              <AcceptInput
                :isRequired="false"
                placeholder="Middle Name"
                ref="txtMiddleName"
                v-model="visitor_Param.MiddleName"
                maxlength="256"
                regExp="([a-zA-Z\s])*"
                title="Enter Middle Name"
              />
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: true }">Last Name</span>
              <AcceptInput
                :isRequired="true"
                placeholder="Last Name"
                ref="txtLastName"
                v-model="visitor_Param.LastName"
                maxlength="256"
                regExp="([a-zA-Z\s])*"
                title="Enter Last Name"
              />
            </div>
          </div>
          <div class="Flex_Row">
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: true }">Gender</span>
              <span v-for="(g, index) in gender_List" :key="g[0]">
                <input
                  type="radio"
                  name="rblGender"
                  v-model="visitor_Param.GenderID"
                  :value="g[0]"
                  :id="'gender_' + index"
                />
                <label :for="'gender_' + index">{{ g[1] }}</label>
              </span>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: true }">Date of Birth</span>
              <DateControl
                :isRequired="true"
                v-model="visitor_Param.DOB"
                :showDate="false"
                title="Enter Date of birth"
              ></DateControl>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: true }">Mobile No</span>
              <AcceptInput
                :isRequired="true"
                type="mobile"
                ref="txtMobileNumber"
                v-model="visitor_Param.Mobile"
                title="Your mobile number on which all updates can be received"
              />
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: false }">Email ID</span>
              <AcceptInput
                type="email"
                ref="txtEmailID"
                :isRequired="false"
                v-model="visitor_Param.Email"
                title="Your email ID on which communication will be sent"
              ></AcceptInput>
            </div>
          </div>
          <div class="Flex_Row">
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: false }">Address</span>
              <textarea
                ref="fullAdd"
                v-model="visitor_Param.FullAddress"
                placeholder="ENTER FULL ADDRESS"
                title="ENTER FULL ADDRESS"
                maxlength="500"
                v-on:keypress="validateAddress($event)"
                @click.right.prevent
                @copy.prevent
                @paste.prevent
              ></textarea>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: true }">ID Type</span>
              <select id="ddlIDType" v-model="visitor_Param.IDType">
                <option value="-1">---Select---</option>
                <option v-for="i in idType_List" :key="i[0]" v-bind:value="i[0]">{{ i[1] }}</option>
              </select>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: true }">ID Number</span>
              <AcceptInput
                maxlength="30"
                ref="idNumber"
                type="textbox"
                :isRequired="true"
                placeholder="PLEASE ENTER DOCUMENT NUMBER"
                v-model="visitor_Param.IDNumber"
                class="CreateAccount"
              />
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: true }">ID File</span>
              <input type="file" ref="uploadFilesDocs" v-on:change="documentsPosting()" />
              <span style="color: red">(File Size upto 50 kb) (.pdf/.jpg/.jpeg/.png areallowed)</span>
              <span v-if="upFiles.length > 0">
                {{
                upFiles[0].docFileName
                }}
              </span>
            </div>
          </div>
          <div class="Flex_Row">
            <div class="Flex_Cell" align="center" valign="middle">
              <input
                v-if="isTicketGenerated == 0"
                type="button"
                id="btnSave"
                name="btnSave"
                btnName="btnSave"
                value="Save Visitors' Information"
                title="Click to Save detail"
                style="margin: 0px; padding: 5px 15px; font-size: medium"
                v-on:click="saveVisitorData()"
              />
            </div>
          </div>
        </div>
        <div class="Flex_Table ekkGrid" style="font-size: small" v-if="visitorData_List.length > 0">
          <div class="Flex_Row GridHeader">
            <div class="Flex_Cell">Name</div>
            <div class="Flex_Cell" style="width: 10%">DOB</div>
            <div class="Flex_Cell" style="width: 15%">IDType</div>
            <div class="Flex_Cell" style="width: 15%">IDNumber</div>
            <div class="Flex_Cell" style="width: 15%">Mobile</div>
            <div class="Flex_Cell" style="width: 15%">Email</div>
          </div>
          <div class="GridContent">
            <div class="Flex_Row" v-for="v in visitorData_List" :key="v.visitorID">
              <div class="Flex_Cell" align="center" valign="middle">
                {{ v.titleName }} {{ v.firstName }} {{ v.middleName }}
                {{ v.lastName }}
              </div>
              <div class="Flex_Cell" align="center" valign="middle" style="width: 10%">{{ v.dob }}</div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width: 15%"
              >{{ v.idTypeName }}</div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width: 15%"
              >{{ v.idNumber }}</div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width: 15%"
              >{{ v.mobile }}</div>
              <div class="Flex_Cell" align="center" valign="middle" style="width: 15%">{{ v.email }}</div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset class="EntryBlock" v-show="tabID == 4 || tabID == 3">
        <legend>{{ currentTabName }}</legend>
        <div class="Flex_Table" v-if="isTicketGenerated == 0">
          <div class="Flex_Row" align="center">
            <div class="Flex_Cell" style="padding: 10px">
              <span>
                <input
                  id="isDisclamer"
                  type="checkbox"
                  :name="'isDisclamer'"
                  value="0"
                  v-model="isDisclamer"
                  v-on:click="isDisclamerChecked()"
                />
                <label :for="'isDisclemer'" style="padding-left: 10px">
                  I understand and agree to the privacy policy,
                  <a
                    style="color: #11ade9"
                    @click="openTNC()"
                  >Term & Conditions</a>
                  and Cancellation policy for the booking.
                </label>
              </span>
            </div>
          </div>
          <div
            class="Flex_Row"
            align="center"
            width="100%"
            v-if="isTicketGenerated == 0 && isDisclamer == 1"
          >
            <div class="Flex_Cell" align="center" width="30%">
              <div class="Flex_Table">
                <div class="Flex_Row" width="30%">
                  <div class="Flex_Cell" valign="middle">
                    <AcceptInput
                      maxlength="6"
                      ref="captchaValue"
                      type="textbox"
                      :isRequired="true"
                      placeholder="CAPTCHA"
                      v-model="captchaValue"
                      class="CreateAccount"
                      regExp="([A-Za-z0-9])*"
                    />
                  </div>
                  <div class="Flex_Cell" valign="middle">
                    <img id="imgCaptcha" style="border: 1px solid #000" />
                  </div>
                  <div class="Flex_Cell" valign="middle">
                    <img
                      src="../assets/images/refresh.png"
                      v-on:click="generateCaptcha()"
                      style="cursor: pointer;height: 25px;border: 1px solid #000;border-radius: 50%;"
                      title="Click here to refresh captcha"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="Flex_Row"
            align="center"
            v-if="isTicketGenerated == 0 && isOnlinePaymentReq == 1"
          >
            <div class="Flex_Cell">
              <input
                v-if="isTicketGenerated == 0"
                type="button"
                :disabled="isDisclamer == 0"
                id="btnGenerate"
                name="btnGenerate"
                btnName="btnGenerate"
                value="Pay Now"
                title="Click here to payment"
                @click="redirectToTransReq()"
                style="margin: 0px; padding: 5px 15px; font-size: medium"
              />
            </div>
          </div>
          <div
            class="Flex_Row"
            align="center"
            v-if="isTicketGenerated == 0 && isOnlinePaymentReq == 0"
          >
            <div class="Flex_Cell">
              <input
                v-if="isTicketGenerated == 0"
                type="button"
                :disabled="isDisclamer == 0"
                id="btnGenerate"
                name="btnGenerate"
                btnName="btnGenerate"
                value="Generate Ticket"
                title="Click to generate ticket"
                style="margin: 0px; padding: 5px 15px; font-size: medium"
                v-on:click="onClickGenerateTicket()"
              />
            </div>
          </div>
        </div>
        <div v-if="isTicketGenerated == 1">
          <div class="Flex_Table">
            <div class="Flex_Row">
              <div class="Flex_Cell pageClass" id="divTicketPrinting">
                <div class="Flex_Table tblEntryForm" width="40%">
                  <div class="Flex_Row">
                    <div class="Flex_Cell" valign="middle" style="width: 30%" align="center">
                      <div
                        style="padding-top: 10px"
                        id="divQRCodeData"
                        oncontextmenu="return true;event.stopPropagation();"
                      ></div>
                    </div>
                    <div class="Flex_Cell" valign="middle" style="width: 70%">
                      <div class="Flex_Table" style="padding-top: 20px">
                        <div class="Flex_Row" align="center">
                          <div class="Flex_Cell">
                            <img src="../assets/images/logoa.png" class="imgHeight" />
                          </div>
                        </div>
                        <div class="Flex_Row tblRow">
                          <div class="Flex_Cell" width="45%">
                            <b>Ticket No.</b>
                          </div>
                          <div class="Flex_Cell" width="10%">
                            <b>:</b>
                          </div>
                          <div class="Flex_Cell" width="45%">{{ bookingData[0].ticketNo }}</div>
                        </div>
                        <div class="Flex_Row tblRow" v-if="bookingData[0].slotDetails != ''">
                          <div class="Flex_Cell" width="45%">
                            <b>Slot</b>
                          </div>
                          <div class="Flex_Cell" width="10%">
                            <b>:</b>
                          </div>
                          <div class="Flex_Cell" width="45%">{{ bookingData[0].slotDetails }}</div>
                        </div>
                        <div class="Flex_Row tblRow">
                          <div class="Flex_Cell" width="45%">
                            <b>Date</b>
                          </div>
                          <div class="Flex_Cell" width="10%">
                            <b>:</b>
                          </div>
                          <div class="Flex_Cell" width="45%">{{ bookingData[0].bookingDates }}</div>
                        </div>
                        <div class="Flex_Row tblRow">
                          <div class="Flex_Cell" width="45%">
                            <b>No. of Individuals</b>
                          </div>
                          <div class="Flex_Cell" width="10%">
                            <b>:</b>
                          </div>
                          <div class="Flex_Cell" width="45%">{{ bookingData[0].noOfIndividuals }}</div>
                        </div>
                        <div class="Flex_Row tblRow">
                          <div class="Flex_Cell" width="45%">
                            <b>Amount</b>
                          </div>
                          <div class="Flex_Cell" width="10%">
                            <b>:</b>
                          </div>
                          <div class="Flex_Cell" width="45%">{{ bookingData[0].totalAmount }}</div>
                        </div>
                        <div class="Flex_Row tblRow">
                          <div class="Flex_Cell" width="45%">
                            <b>Ticket Status</b>
                          </div>
                          <div class="Flex_Cell" width="10%">
                            <b>:</b>
                          </div>
                          <div class="Flex_Cell" width="45%">
                            <span
                              style="color: green;"
                              v-if="bookingData[0].isPaymentRefunded == 0"
                            >Ticket Booked</span>
                            <span
                              style="color: orange;"
                              v-if="bookingData[0].isPaymentRefunded == 2"
                            >Refund Initiated</span>
                            <span
                              style="color: green;"
                              v-if="bookingData[0].isPaymentRefunded == 1"
                            >Amount Refunded</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <table class="BoxDesign" style="display: none">
                  <tr>
                    <td valign="top">
                      <div
                        style="padding-top: 10px"
                        id="divQRCodeData"
                        oncontextmenu="return true;event.stopPropagation();"
                      ></div>
                    </td>
                    <td valign="top">
                      <table
                        class="ticketTable"
                        v-if="isTicketGenerated == 1 && bookingData.length > 0"
                      >
                        <tr>
                          <td colspan="2" style="text-align: center">
                            <img src="../assets/images/logoa.png" style="height: 70px" />
                          </td>
                        </tr>
                        <tr>
                          <td>Ticket No</td>
                          <td>{{ bookingData[0].ticketNo }}</td>
                        </tr>
                        <tr v-if="bookingData[0].slotDetails != ''">
                          <td>Slot</td>
                          <td>{{ bookingData[0].slotDetails }}</td>
                        </tr>
                        <tr>
                          <td>Date</td>
                          <td>{{ bookingData[0].bookingDates }}</td>
                        </tr>
                        <tr>
                          <td style="width: 150px">Person number</td>
                          <td>{{ bookingData[0].noOfIndividuals }}</td>
                        </tr>
                        <tr>
                          <td>Amount</td>
                          <td>{{ bookingData[0].totalAmount }}</td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell_Inline">
                <input
                  type="button"
                  style="padding: 10px"
                  value="Show Ticket"
                  v-on:click="showTicket()"
                  v-if="isTicketGenerated == 1"
                  title="Click to Show Ticket"
                />
              </div>
              <div class="Flex_Cell_Inline">
                <input
                  type="button"
                  style="padding: 10px; background-color: red;"
                  value="Cancel Ticket"
                  v-on:click="confirmCancel1()"
                  v-if="refundCanBeMade == 1"
                  title="Click to Cancel Ticket"
                />
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <!-- </transition> -->
      <div class="Flex_Table" v-if="bookingID != -1">
        <div class="Flex_Row">
          <div class="Flex_Cell" style="width: 15%">
            <!-- <span  class="radioSpan" v-if="tabID>1" v-on:click="onPrevTabClick()" 
                                                                                                                :title="'Click go to'+prevTabName ">
                                                                                                                {{prevTabName}}
            </span>-->
          </div>
          <div class="Flex_Cell" align="center">
            <!-- <step-progress :steps="bookingStages"  ></step-progress> -->
            <span class="radioSpan" v-if="this.tabID != 1" v-on:click="onPrevTabClick()">Back</span>
            <span
              class="radioSpan"
              v-if="this.tabID < this.bookingStages.length"
              v-on:click="onNextTabClick()"
            >Next</span>
            <!-- <span
              class="radioSpan"
              v-for="b in bookingStages"
              :key="b.stageSerialNo"
              :style="
                b.stageRequired == 0
                  ? { display: 'none' }
                  : b.stageSerialNo == tabID
                  ? { display: 'none' }
                  : ''
              "
                                                                                                  v-on:click="tabID = b.stageSerialNo"
                                                                                                  >{{ b.stageName }}</span
            >-->
          </div>
          <div class="Flex_Cell" style="width: 15%" align="right">
            <!-- <span  class="radioSpan"  v-if="tabID<4" v-on:click="onNextTabClick()" 
                                                                                                                :title="'Click go to'+nextTabName ">
                                                                                                                {{nextTabName}}
            </span>-->
          </div>
        </div>
      </div>
    </div>
    <ModalPopup
      title="Ticket Print"
      ref="ModalPopup1"
      @closed="modalPopupClosed"
      @opened="modalPopupShown"
      v-model="ticketPrintDiv"
      :okButton="$refs.btnOk"
      :cancelButton="$refs.btnOk"
      v-if="TicketNo != ''"
      class="tblEntryForm"
    >
      <div style="height: calc(100vh - 100px); width: 50%">
        <PrintTicket :TicketNo="TicketNo" :eventBus="printbus"></PrintTicket>
      </div>
      <div style="text-align: center" class="background">
        <!-- <input type="button" value="Print" v-on:click="printPDFReport()" />         -->
      </div>
    </ModalPopup>
    <ModalPopup
      title="Term & Conditions"
      ref="ModalPopupTNC"
      @closed="modalPopupClosed"
      @opened="modalPopupShown"
      v-model="TNCDiv"
      :okButton="$refs.btnOk"
      :cancelButton="$refs.btnOk"
    >
      <div style="height: calc(105vh - 100px); width: 100%; align: center">
        <TNC :eventBus="printbus"></TNC>
      </div>
      <div style="text-align: center" class="background">
        <!-- <input type="button" value="Print" v-on:click="printPDFReport()" />         -->
      </div>
    </ModalPopup>
    <ModalPopup
      title="Cancellation Policy"
      ref="ModalPopupCancellationPolicy"
      @closed="modalPopupClosed"
      @opened="modalPopupShown"
      v-model="isCancellationPolicy"
      :okButton="$refs.btnOk"
      :cancelButton="$refs.btnOk"
    >
      <div style="width: 100%; align: center">
        <TNC :eventBus="printbus" :isCancellationPolicy="isCancellationPolicy"></TNC>
      </div>
      <div style="text-align: center" class="background">
        <!-- <input type="button" value="Print" v-on:click="printPDFReport()" />         -->
      </div>
    </ModalPopup>
  </div>
</template>
<script>
import vue from "vue";
import AcceptInput from "./ekkControls/AcceptInput";
import DateControl from "./ekkControls/DateControl";
import bookingAPI from "./servicesJS/Booking.js";
import MasterJS from "./servicesJS/Master.js";
import LoginJs from "./servicesJS/Login.js";
import TicketJS from "./servicesJS/Ticket.js";
import "vue-step-progress/dist/main.css";
import stepProgress from "./ekkControls/StepProgressSlider";
import SlotCalender from "./ekkControls/SlotCalender";
import Report from "@/router/Report";
import TNC from "@/components/TermNCond";
import ModalPopup from "./ekkControls/ModalPopup";
import biometricJS from "../router/biometric.js";

export default {
  name: "TicketBooking",
  components: {
    DateControl: DateControl,
    AcceptInput: AcceptInput,
    "slot-calendar": SlotCalender,
    TNC: TNC,
    "step-progress": stepProgress,
    ModalPopup: ModalPopup
  },
  data() {
    return {
      isCancellationPolicy: false,
      TNCDiv: false,
      calbus: new vue(),
      isNewEdit: false,
      tabID: 1,
      currentTabName: "Booking",
      nextTabName: "Contact Detail",
      prevTabName: "",
      bookingStages: [],
      currentStep: 1,
      bookingID: -1,
      isOnlinePaymentReqd: 0,
      isOnlinePaymentReq: 0,
      isVisitorsInfoReqd: 0,
      deductFreeEntryFromCount: 0,
      bookingType_List: [],
      bookingTypeID: 1,
      bookingForUnit: 0,
      availableSlot_List: [],
      seatLeftForSlot: 0,
      seatLeftForGroup: 0,
      timeSlotID: -1,
      minDate: new Date(),
      maxDate: new Date().addYears(1),
      bookingDate: new Date().addDays(1),
      personAgeGroup_List: [],
      bookingFromDate: new Date().addDays(1),
      bookingToDate: new Date().addDays(1),
      bookingDays: 0,
      myBooking_List: [],
      bookingData: [],
      //savedPersonAgeGroup_List:[],
      taxRates_List: [],
      totalPerson: 0,
      totalAmount: 0,
      totalCGST: 0,
      totalSGST: 0,
      otherTaxs: 0,
      promoCode: "",
      discountAmount: 0,
      finalTotalAmount: 0,
      gender_List: [],
      title_List: [],
      idType_List: [],
      visitorData_List: [],
      visitorDOB: "",
      visitor_Param: {
        BookingID: -1,
        VisitorID: -1,
        MemberID: -1,
        TitleID: -1,
        FirstName: "",
        MiddleName: "",
        LastName: "",
        DOB: "",
        GenderID: 0,
        GenderName: "",
        IDType: -1,
        IDTypeName: "",
        IDNumber: "",
        IDImageFile: null,
        IDGetImageFile: "",
        Email: "",
        Mobile: "",
        FullAddress: "",
        IsSelected: "1",
        FileName: ""
      },
      upFiles: [],
      ticketQRCode: "",
      isTicketGenerated: 0,
      printbus: new vue(),
      ticketPrintDiv: false,
      TicketNo: "",
      stages: [],
      isPromoCodeRequired: 0,
      isVisitorDataRequired: 0,
      isBookingSaved: 0,
      visitorParam: [],
      isDisclamer: 0,
      isDisclamerCheck: 0,
      isFirstTimeBookingSaved: 0,
      captchaKey: "",
      captchaValue: "",
      userTypeID: -1,

      isQuotaUsed: 0,
      rbFilterQuota: "0",
      refundCanBeMade: 0,
      cancelReason: ""
    };
  },
  methods: {
    modalPopupShown(e) {
      //this.printPDFReport();
    },
    modalPopupClosed(e) {
      this.isCancellationPolicy = false;
      this.printbus = new vue();
    },
    openTNC() {
      let self = this;
      vue.nextTick(function() {
        self.TNCDiv = true;
      });
    },
    isDisclamerChecked() {
      if (this.isDisclamer == 0) {
        this.isDisclamerCheck = 1;
        this.generateCaptcha();
      } else {
        this.isDisclamerCheck = 0;
      }
    },
    selectedDate(value) {
      if (this.isTicketGenerated == 0) {
        if (this.bookingForUnit == 0) {
          this.bookingDate = new Date(value);
        } else {
          this.bookingFromDate = new Date(value);
        }
      }
    },
    confirmCancel1() {
      MessageBox.show(
        {
          message:
            "Cancel Reason<br/><textarea id='cancelReason'></textarea><br/>Are you sure to cancel the ticket  ? </br> Click  Yes to continue",
          type: "confirm",
          title: "Confirmation",
          defaultButton: 2
        },
        {
          buttonName: "Yes",
          buttonAction: this.confirmCancel2
        },
        { buttonName: "No", buttonAction: this.showFlashMessage }
      );
    },
    confirmCancel2() {
      if ($("#cancelReason").val() == "") {
        MessageBox.show({
          message: "Please Enter Reason for cancel the ticket",
          type: "confirm",
          title: "Alert"
        });
        return;
      } else {
        this.cancelReason = $("#cancelReason").val();
        MessageBox.show(
          {
            message:
              "Once, you cancel the ticket, </br> it cannot be reverted.",
            type: "confirm",
            title: "Alert",
            defaultButton: 2
          },
          {
            buttonName: "Yes",
            buttonAction: this.goToCancelTicket
          },
          { buttonName: "No", buttonAction: this.showFlashMessage }
        );
      }
    },
    goToCancelTicket() {
      this.$root.$data.BookingID = this.bookingData[0].bookingID;
      this.$root.$data.CancelReason = this.cancelReason;
      this.$root.$data.PageName = "TicketBooking";
      this.$router.push({ name: "RefundRequest" });
    },
    showTicket() {
      //alert('this.TicketNo : ' + this.TicketNo)
      //console.log(this.bookingData);
      const basicData = {
        FileName: "Ticket",
        FileFormat: "PDF",
        FileExtension: "pdf",
        Param1: "Ticket",
        Param2: "",
        BookingID: this.bookingData[0].bookingID,
        TicketNo: this.bookingData[0].ticketNo,
        type: 1
      };
      var formData = new FormData();
      formData.append("BasicFormData", JSON.stringify(basicData));
      TicketJS.ShowPrintTicket(formData).then(
        response => {
          var msg = Report.showReport(response.data.result, false);
          if (msg == false) {
            MessageBox.show({
              message: "No Record Found",
              type: "error",
              title: "Error"
            });
          }
        },
        error => {}
      );
    },
    onNextTabClick() {
      this.tabID++;
      this.TabMovment(true);
    },
    onPrevTabClick() {
      this.tabID--;
      this.TabMovment(false);
    },
    TabMovment(isNext) {
      let self = this;
      this.isDisclamer = 0;
      let isfound = this.bookingStages.filter(b => {
        return b.stageSerialNo == self.tabID;
      });
      if (isfound.length <= 0 && isNext) {
        this.tabID++;
        this.TabMovment(true);
      }
      if (isfound.length <= 0 && !isNext) {
        this.tabID--;
        this.TabMovment(false);
      }
    },
    validateAddress: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      var ok =
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 96 && charCode <= 105) ||
        (charCode >= 97 && charCode <= 122) ||
        charCode == 45 ||
        charCode == 32 ||
        charCode == 44 ||
        charCode == 47;
      if (!ok) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    backToMyBoking() {
      this.bookingType_List = [];
      this.isNewEdit = false;
      this.bookingID = -1;
      this.masterDataReset();
      this.showMyBooking();
      this.isPromoCodeRequired = 0;
      this.isVisitorDataRequired = 0;
      this.isBookingSaved = 0;
      this.bookingTypeID = 1;
      this.bookingForUnit = 0;
      this.availableSlot_List = [];
      this.seatLeftForSlot = 0;
      this.seatLeftForGroup = 0;
      this.timeSlotID = -1;
      this.minDate = new Date();
      this.maxDate = new Date().addYears(1);
      this.personAgeGroup_List = [];
      this.bookingFromDate = new Date().addDays(1);
      this.bookingToDate = new Date().addDays(1);
      this.bookingDays = 0;
      this.visitor_Param.BookingID = -1;
      this.visitor_Param.VisitorID = -1;
      this.visitor_Param.MemberID = -1;
      this.visitor_Param.TitleID = -1;
      this.visitor_Param.FirstName = "";
      this.visitor_Param.MiddleName = "";
      this.visitor_Param.LastName = "";
      this.visitor_Param.DOB = "";
      this.visitor_Param.GenderID = 0;
      this.visitor_Param.GenderName = "";
      this.visitor_Param.IDType = -1;
      this.visitor_Param.IDTypeName = "";
      this.visitor_Param.IDNumber = "";
      this.visitor_Param.IDImageFile = null;
      this.visitor_Param.IDGetImageFile = "";
      this.visitor_Param.Email = "";
      this.visitor_Param.Mobile = "";
      this.visitor_Param.FullAddress = "";
      this.visitor_Param.IsSelected = "1";
      this.visitor_Param.FileName = "";
      this.getBookingType();
      this.isDisclamer = 0;
      this.rbFilterQuota = "0";
    },
    masterDataReset() {
      this.tabID = 1;
      this.bookingID = -1;
      this.bookingStages = [];
      this.personAgeGroup_List = [];
      this.bookingData = [];
      this.ticketQRCode = "";
      this.isTicketGenerated = 0;
      //this.savedPersonAgeGroup_List=[];
    },
    newBookingClick() {
      this.isCancellationPolicy = true;
      this.isNewEdit = true;
      this.bookingID = -1;
      this.bookingDate = new Date().addDays(1);
      this.masterDataReset();
      this.getGenralMaster();
      this.getBookingStages();
      this.getBookingType();
      //this.getPersonAgeGroup();
      this.getAvailableSlot();
      this.getSavedBookingData(-1);
      this.isBookingSaved = 1;
      this.bookingTypeID = this.bookingTypeID;
    },
    getGenralMaster() {
      bookingAPI.getTitle().then(
        result => {
          this.title_List = result.data;
        },
        error => {}
      );
      bookingAPI.getGender().then(
        result => {
          this.gender_List = result.data;
        },
        error => {}
      );
      bookingAPI.getIDType().then(
        result => {
          this.idType_List = result.data;
        },
        error => {}
      );
      this.getBookingStages();
    },
    getBookingStages(id) {
      let self = this;
      self.bookingStages = [];
      bookingAPI.getBookingStages({ bookingID: self.bookingID }).then(
        result => {
          if (result.data.result) {
            this.getBookingType();
            self.bookingStages = result.data.result.filter(b => {
              return b.stageRequired == 1;
            });
            self.stages = self.bookingStages;
            //console.log(self.bookingStages);
            if (id) {
              //console.log(self.bookingStages);
              if (self.bookingStages.length > 0) {
                for (let i = 0; i < self.bookingStages.length; i++) {
                  if (
                    parseInt(self.bookingStages[i].stageSerialNo) > parseInt(id)
                  ) {
                    self.tabID = self.bookingStages[i].stageSerialNo;
                    return;
                  }
                }
              }
            }
          }
        },
        error => {}
      );
    },
    getBookingType() {
      this.bookingType_List = [];
      bookingAPI.getBookingType({}).then(
        result => {
          this.bookingType_List = result.data;
        },
        error => {}
      );
    },
    getAvailableSlot(slotID) {
      // this.timeSlotID = -1;
      //console.log(this.bookingDate);
      this.availableSlot_List = [];
      if (this.bookingDate != "" || this.bookingFromDate != "") {
        var _date = "";
        if (this.bookingForUnit == 1) {
          var _date = this.bookingFromDate;
        } else {
          var _date = this.bookingDate;
        }
      } else {
        return false;
      }
      var type = 1;
      if (this.rbFilterQuota == 1) {
        type = 2;
      }
      const _data_ = {
        bookingTypeID: this.bookingTypeID,
        bookingDate: _date,
        type: type
      };
      bookingAPI.getAvailableSlots(_data_).then(
        result => {
          this.availableSlot_List = result.data;
          if (result.data.length > 0) {
            if (slotID) {
              this.timeSlotID = slotID;
              vue.nextTick(() => {
                this.getSeatLeftForSlot();
              });
            } else {
              this.timeSlotID = result.data[0][0];
              if (this.bookingForUnit == 1) {
                var seatsLeft = this.availableSlot_List[0][2];
                this.seatLeftForGroup = seatsLeft;
              } else {
                vue.nextTick(() => {
                  this.getSeatLeftForSlot();
                });
              }
            }
          }
        },
        error => {}
      );
    },
    getSeatLeftForSlot() {
      //alert('123');
      this.seatLeftForSlot = 0;
      var type = 1;
      if (this.rbFilterQuota == 1) {
        type = 2;
      }
      bookingAPI
        .getSeatLeft({
          bookingID: this.bookingID,
          slotID: this.timeSlotID,
          bookingTypeID: this.bookingTypeID,
          type: type
        })
        .then(
          result => {
            this.seatLeftForSlot = result.data;
            this.seatLeftForGroup = result.data;
          },
          error => {}
        );
    },
    // getPersonAgeGroup(){
    //     this.personAgeGroup_List=[];
    //     bookingAPI.getPersonAgeGroup({bookingTypeID:this.bookingTypeID}).then(result=>{
    //         if(result.data.result){
    //             this.personAgeGroup_List = result.data.result;
    //         }
    //         vue.nextTick(()=>{
    //             this.getTaxRates();
    //         });
    //     },error=>{});
    // },
    getTaxRates() {
      this.taxRates_List = [];
      bookingAPI.getTax({}).then(
        result => {
          if (result.data.result) {
            this.taxRates_List = result.data.result;
          }
        },
        error => {}
      );
    },
    addPerson(row) {
      if (this.bookingForUnit == 0) {
        if (row.noOfIndividuals >= 99) {
          row.noOfIndividuals = 99;
        } else {
          row.noOfIndividuals++;
        }
      } else {
        row.noOfIndividuals++;
      }
    },
    minusPerson(row) {
      if (row.noOfIndividuals <= 0) {
        row.noOfIndividuals = 0;
      } else {
        row.noOfIndividuals--;
      }
    },
    saveBooking() {
      //this.stages = [];
      var _errorMsg = "";
      var _isError = false;
      var date = "01 Jan 1900";
      var todate = "01 Jan 1900";
      if (this.bookingForUnit == 0) {
        if (this.bookingDate != "") {
          date = new Date(this.bookingDate).convertToString("dd MMM yyyy");
        } else {
          _isError = true;
          _errorMsg += "Please Select Date </br>";
        }
        if (this.timeSlotID == -1) {
          _isError = true;
          _errorMsg += "Please Select Slot Timing</br>";
        }
      } else {
        if (this.bookingFromDate != "") {
          date = new Date(this.bookingFromDate).convertToString("dd MMM yyyy");
        } else {
          _isError = true;
          _errorMsg += "Please Select From Date</br>";
        }
        if (this.bookingToDate != "") {
          todate = new Date(this.bookingToDate).convertToString("dd MMM yyyy");
        } else {
          _isError = true;
          _errorMsg += "Please Select To Date</br>";
        }
      }
      if (this.bookingForUnit == 0) {
        if (this.totalPerson == 0) {
          _isError = true;
          _errorMsg += "Please Select at least 1 Person</br>";
        }
      } else {
        if (this.totalPerson == 0) {
          _isError = true;
          _errorMsg += "Please Select at least 1 Group</br>";
        }
      }
      // if (this.finalTotalAmount == 0) {
      //   _isError = true;
      //   _errorMsg += "Total Amount will not be Zero";
      // }
      if (this.isVisitorDataRequired == 0) {
        // if (this.visitor_Param.TitleID == -1) {
        //   _isError = true;
        //   _errorMsg += "Please Select Title </br>";
        // }
        if (this.visitor_Param.FirstName == "") {
          _isError = true;
          _errorMsg += "Please Enter First Name </br>";
        }
        if (this.visitor_Param.LastName == "") {
          _isError = true;
          _errorMsg += "Please Enter last Name </br>";
        }
        if (this.visitor_Param.GenderID == 0) {
          _isError = true;
          _errorMsg += "Please Select Gender </br>";
        }
        if (this.visitor_Param.DOB == "") {
          _isError = true;
          _errorMsg += "Please Enter DOB </br>";
        }
      }
      if (_isError) {
        MessageBox.show({
          message: _errorMsg,
          type: "error",
          title: "Error"
        });
        return;
      }
      //console.log(this.totalPerson);
      //console.log(this.personAgeGroup_List);

      // if (this.rbFilterQuota == 2) {
      //   this.isQuotaUsed = 1;
      // } else {
      //   this.isQuotaUsed = 0;
      // }
      const BasicData = {
        BookingID: this.bookingID,
        MemberID: -1,
        BookingTypeID: this.bookingTypeID,
        SlotID: this.timeSlotID,
        FromDate: date,
        ToDate: todate,
        NoOfIndividuals: this.totalPerson,
        Amount: this.totalAmount,
        CGST: this.totalCGST,
        SGST: this.totalSGST,
        OtherTaxAmount: this.otherTaxs,
        IsDiscountGiven:
          this.discountAmount == "0" ? 0 : this.discountAmount == "" ? 0 : 1,
        PromoCode: this.promoCode,
        DiscountAmount: this.discountAmount,
        TotalAmount: this.finalTotalAmount,
        Type: 1,
        IsQuotaUsed: this.rbFilterQuota,
        BookingIndividuals: this.personAgeGroup_List
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(BasicData));
      bookingAPI.saveBooking(formData).then(
        result => {
          //console.log(result);
          if (result.data.isSuccess) {
            if (result.data.result) {
              let _str = result.data.result.split("~");
              this.bookingID = _str[0];
              this.isOnlinePaymentReqd = _str[1];
              this.isVisitorsInfoReqd = _str[2];
              this.deductFreeEntryFromCount = _str[3];
              this.getSavedBookingData(_str[0]);
            }
            this.isBookingSaved = 1;
            if (this.isVisitorDataRequired == 0) {
              this.visitor_Param.BookingID = this.bookingID;
              this.visitor_Param.FileName = "0x";
              var formData = new FormData();
              formData.append(
                "FileInfoData",
                JSON.stringify(this.visitor_Param)
              );
              formData.append("file", "");
              bookingAPI.saveSingleVisitorData(formData).then(
                result => {
                  if (result.data.isSuccess) {
                    MessageBox.show({
                      message: result.data.msg,
                      type: "success",
                      title: "Success"
                    });
                    this.bookingTypeID = this.bookingTypeID;
                    vue.nextTick(() => {
                      this.getSingleVisitorData();
                      this.getBookingStages();
                      this.isFirstTimeBookingSaved = 1;
                    });
                    vue.nextTick(() => {
                      this.getBookingStages(this.tabID);
                      //console.log(this.stages);
                    });
                  } else {
                    MessageBox.show({
                      message: result.data.msg,
                      type: "error",
                      title: "Message"
                    });
                  }
                },
                error => {}
              );
            } else {
              MessageBox.show({
                message: result.data.msg,
                type: "success",
                title: "Success"
              });
            }
          } else {
            MessageBox.show({
              message: result.data.msg,
              type: "error",
              title: "Error"
            });
          }
        },
        error => {}
      );
    },
    showMyBooking(BookingID, isSuccess, isRefund) {
      this.myBooking_List = [];
      bookingAPI.showMyBooking({ bookingTypeID: -1, type: 1 }).then(
        result => {
          this.myBooking_List = result.data;
          //console.log("mont");
          if (result.data.length <= 0) {
            //this.isNewEdit=true;
            this.newBookingClick();
          } else {
            this.isNewEdit = false;
            if (BookingID != -1 && BookingID != null) {
              this.responseFromPayment(BookingID, isSuccess, isRefund);
            }
          }
        },
        error => {}
      );
    },
    getMyBookingOnClick(row) {
      self = this;
      if (row) {
        //console.log(row);
        this.isNewEdit = true;
        this.bookingID = row.bookingID;
        this.rbFilterQuota = row.isQuotaUsed;
        this.bookingTypeID = row.bookingTypeID;
        // vue.nextTick(()=>{
        //     this.getPersonAgeGroup();
        // });
        vue.nextTick(() => {
          this.getVisitorData();
          this.getSingleVisitorData();
        });
        vue.nextTick(() => {
          this.getBookingStages();
        });
        //vue.nextTick(() => {});
        this.bookingDate = new Date(row.fromDate);
        this.bookingFromDate = new Date(row.fromDate);

        this.getSavedBookingData(row.bookingID);
        this.getAvailableSlot(row.slotID);

        // if (typeof callBack === "function") {
        //   callBack;
        // }
        // window.setTimeout(function(){
        //     self.getSavedBookingData(row.bookingID);
        // },500);
      }
    },
    getSavedBookingData(id) {
      bookingAPI
        .getBookingData({ bookingID: id, bookingTypeID: this.bookingTypeID })
        .then(
          result => {
            if (result.data.result) {
              this.bookingData = result.data.result;
              this.isTicketGenerated = result.data.result[0].isTicketGenerated;
              this.refundCanBeMade = result.data.result[0].refundCanBeMade;
              this.ticketQRCode = result.data.result[0].qrcode;
              this.isBookingSaved = 1;
              this.isQuotaUsed = result.data.result[0].isQuotaUsed;
              if (id != -1) {
                this.rbFilterQuota = this.isQuotaUsed;
              } else {
                this.rbFilterQuota = "0";
              }
              this.bookingTypeID = this.bookingTypeID;
              if (result.data.result[0].isTicketGenerated == "1") {
                vue.nextTick(() => {
                  let divQRCodeData = document.getElementById("divQRCodeData");
                  let QRCodeData = result.data.result[0].qrcode;
                  let img = document.createElement("img");
                  img.src = "data:image/jpg; base64," + QRCodeData;
                  //img.src =  QRCodeData;
                  divQRCodeData.innerHTML = "";
                  divQRCodeData.appendChild(img);
                  this.isFirstTimeBookingSaved = 1;
                });
              }
            }
            if (result.data.result1) {
              this.personAgeGroup_List = result.data.result1;
              this.getAvailableSlot();
              // this.personAgeGroup_List.forEach(element => {
              //     if(self.savedPersonAgeGroup_List.length>0){
              //         self.savedPersonAgeGroup_List.forEach(savedelement => {
              //             if(element.personAgeGroupID==savedelement.personAgeGroupID){
              //                 element.noOfPerson = savedelement.noOfIndividuals;
              //                 element.totalAmount = savedelement.totalAmount;
              //             }
              //         });
              //     }
              // });
            }
          },
          error => {}
        );
    },
    getVisitorData() {
      this.visitorData_List = [];
      bookingAPI.getVisitorDataMain({ bookingID: this.bookingID }).then(
        result => {
          if (result.data.result) {
            this.visitorData_List = result.data.result;
            this.visitorParam = this.visitorData_List;
          }
          //console.log(result.data);
        },
        error => {}
      );
    },
    clearVisitorData() {
      this.visitor_Param = {
        VisitorID: -1,
        MemberID: -1,
        TitleID: -1,
        FirstName: "",
        MiddleName: "",
        LastName: "",
        DOB: new Date(),
        GenderID: -1,
        GenderName: "",
        IDType: -1,
        IDTypeName: "",
        IDNumber: "",
        IDImageFile: null,
        IDGetImageFile: "",
        Email: "",
        Mobile: "",
        FullAddress: "",
        IsSelected: "0"
      };
      this.upFiles = [];
    },
    documentsPosting() {
      this.upFiles = [];
      var ext = ["PNG", "JPG", "JPEG", "PDF"];
      var me = this;
      var myFiles = [];
      var lstFiles = this.$refs.uploadFilesDocs.files;
      var isValidExtension = true;
      var isValidSize = true;
      var checkSize = parseFloat(50 * 1024);

      // 100 KB each
      for (var i = 0; i < lstFiles.length; i++) {
        var fName = lstFiles[i].name;
        var fileExt = fName.split(".").pop();
        if (!(ext.indexOf(fileExt.toUpperCase()) >= 0)) {
          isValidExtension = false;
        }
        var size = lstFiles[i].size;
        if (parseFloat(size) > checkSize) {
          isValidSize = false;
        }
        if (i <= 1) {
          myFiles.push(lstFiles[i]);
        }
        //console.log(size +":"+checkSize) ;
      }
      if (isValidExtension == false) {
        alert("Unsupported media type. only image files are upload");
        return false;
      }
      if (isValidSize == false) {
        alert("Individual image files size are more than 500 KB.");
        return false;
      }

      myFiles.forEach(element => {
        var fName = element.name;
        var fileExt = fName.split(".").pop();
        var reader = new FileReader();
        reader.addEventListener("load", function(e) {
          var object = new Object();
          object.file = element;
          object.filePreview = e.target.result;
          object.docFileName = fName;
          object.percent = 0;
          object.docFileID = "";
          object.isUplodError = false;
          object.isApproved = false;
          object.ext = fileExt;
          me.upFiles.push(object);
        });
        if (ext.indexOf(fileExt.toUpperCase()) >= 0) {
          reader.readAsDataURL(element);
        }
      });
      this.$refs.uploadFilesDocs.value = "";
      //window.setTimeout(() => { me.uploadDocuments(); }, 500);
      //window.setTimeout(() => { me.makingDocFileID(); }, 500);
    },
    saveSingleVisitorData() {
      var _errorMsg = "";
      var _isError = false;
      if (this.visitor_Param.TitleID == -1) {
        _isError = true;
        _errorMsg += "Please Select Title </br>";
      }
      if (this.visitor_Param.FirstName == "") {
        _isError = true;
        _errorMsg += "Please Enter First Name </br>";
      }
      if (this.visitor_Param.LastName == "") {
        _isError = true;
        _errorMsg += "Please Enter last Name </br>";
      }
      if (this.visitor_Param.GenderID == -1) {
        _isError = true;
        _errorMsg += "Please Select Gender </br>";
      }
      if (this.visitor_Param.DOB == "") {
        _isError = true;
        _errorMsg += "Please Enter DOB </br>";
      }
      if (_isError) {
        MessageBox.show({
          message: _errorMsg,
          type: "error",
          title: "Error"
        });
        return;
      }
      this.visitor_Param.BookingID = this.bookingID;
      this.visitor_Param.FileName = "0x";
      if (this.visitor_Param.DOB != "") {
        this.visitor_Param.DOB = this.visitor_Param.DOB.convertToString(
          "dd MMM yyyy"
        );
      }
      var formData = new FormData();
      formData.append("FileInfoData", JSON.stringify(this.visitor_Param));
      formData.append("file", "");
      bookingAPI.saveSingleVisitorData(formData).then(
        result => {
          if (result.data.isSuccess) {
            MessageBox.show({
              message: result.data.msg,
              type: "success",
              title: "Success"
            });
            vue.nextTick(() => {
              this.getSingleVisitorData();
              this.getBookingStages();
            });
          }
        },
        error => {}
      );
    },
    getSingleVisitorData() {
      bookingAPI.getVisitorDataMain({ bookingID: this.bookingID }).then(
        result => {
          if (result.data.result) {
            this.visitorParam = result.data.result;
            this.visitorData_List = result.data.result;
            this.visitor_Param.VisitorID = this.visitorParam[0].visitorID;
            this.visitor_Param.TitleID = this.visitorParam[0].titleID;
            this.visitor_Param.FirstName = this.visitorParam[0].firstName;
            this.visitor_Param.MiddleName = this.visitorParam[0].middleName;
            this.visitor_Param.LastName = this.visitorParam[0].lastName;
            this.visitor_Param.DOB = this.visitorParam[0].dob;
            this.visitor_Param.GenderID = this.visitorParam[0].genderID;
          }
        },
        error => {}
      );
    },
    saveVisitorData() {
      var _errorMsg = "";
      var _isError = false;
      if (this.visitor_Param.TitleID == -1) {
        _isError = true;
        _errorMsg += "Please Select Title </br>";
      }
      if (this.visitor_Param.FirstName == "") {
        _isError = true;
        _errorMsg += "Please Enter First Name </br>";
      }
      if (this.visitor_Param.LastName == "") {
        _isError = true;
        _errorMsg += "Please Enter last Name </br>";
      }
      if (this.visitor_Param.GenderID == -1) {
        _isError = true;
        _errorMsg += "Please Select Gender </br>";
      }
      if (this.visitor_Param.DOB == "") {
        _isError = true;
        _errorMsg += "Please Enter DOB </br>";
      }
      if (this.visitor_Param.Mobile == "") {
        _isError = true;
        _errorMsg += "Please Enter Moibile </br>";
      }
      // if (this.visitor_Param.IDType == "-1") {
      //   _isError = true;
      //   _errorMsg += "Please Enter IDType </br>";
      // }
      // if (this.visitor_Param.IDNumber == "") {
      //   _isError = true;
      //   _errorMsg += "Please Enter IDNumber </br>";
      // }
      if (_isError) {
        MessageBox.show({
          message: _errorMsg,
          type: "error",
          title: "Error"
        });
        return;
      }
      this.visitor_Param.BookingID = this.bookingID;
      if (this.upFiles.length > 0) {
        this.visitor_Param.FileName = this.upFiles[0].docFileName;
      }
      if (this.visitor_Param.DOB != "") {
        this.visitor_Param.DOB = this.visitor_Param.DOB.convertToString(
          "dd MMM yyyy"
        );
      }
      var formData = new FormData();
      formData.append("FileInfoData", JSON.stringify(this.visitor_Param));
      if (this.upFiles.length > 0) {
        formData.append("file", this.upFiles[0].file);
      } else {
        formData.append("file", "0x");
      }

      bookingAPI.saveVisitorData(formData).then(
        result => {
          if (result.data.isSuccess) {
            MessageBox.show({
              message: result.data.msg,
              type: "success",
              title: "Success"
            });
            this.getVisitorData();
            this.clearVisitorData();
            vue.nextTick(() => {
              this.getBookingStages();
            });
          } else {
            this.upFiles = [];
            this.$refs.uploadFilesDocs.value = "";
          }
        },
        error => {}
      );
    },
    onClickGenerateTicket() {
      if (this.isTicketGenerated == 0) {
        if (this.isDisclamerCheck == 0) {
          MessageBox.show({
            message: "Please Check the Term and Conditions",
            type: "error",
            title: "Error"
          });
          return;
        }
        if (this.captchaValue == "") {
          this.generateCaptcha();
          MessageBox.show({
            message: "Please Type Captcha",
            type: "error",
            title: "Error"
          });
          return;
        }
        let error = false;
        let msg = "";
        let self = this;
        if (
          this.visitorData_List.length <= 0 ||
          this.visitorParam.length <= 0
        ) {
          error = true;
        }
        if (error) {
          this.generateCaptcha();
          MessageBox.show({
            message: "Please Enter at least 1 Visitor Details",
            type: "error",
            title: "Error"
          });
          return;
        }
        bookingAPI
          .generateTicketData({
            bookingID: this.bookingID,
            bookingTypeID: this.bookingTypeID,
            captchaValue: biometricJS.encryptAES(this.captchaValue),
            captchaKey: biometricJS.encryptAES(this.captchaKey)
          })
          .then(
            result => {
              if (result.data.isSuccess) {
                MessageBox.show({
                  message: "Ticket has been Generated successfully...",
                  type: "success",
                  title: "Success"
                });
                vue.nextTick(() => {
                  this.getSavedBookingData(this.bookingID);
                  this.getBookingStages();
                });
              } else {
                this.generateCaptcha();
                MessageBox.show({
                  message: result.data.msg,
                  type: "error",
                  title: "Error"
                });
                this.isDisclamerCheck = 0;
                this.isDisclamer = false;
              }
            },
            error => {}
          );
      } else {
        this.generateCaptcha();
        MessageBox.show({
          message: "Ticket Already Generated",
          type: "error",
          title: "Error"
        });
        return;
      }
    },
    printTicket() {
      let _html = "";
      let index = 0;
      let _newConttent = "";
      this.windowPreview;
      if (this.windowPreview != null) {
        this.windowPreview.close();
      }
      this.windowPreview = window.open(
        "",
        "FilePreview",
        "scrollbars,addressbar=no,location=no, resizable=yes,width=750px,height=500px,left=10,top=10"
      );
      _newConttent += '<body style="width: 750px; height: 500px">';
      _newConttent += "<STYLE>";
      _newConttent += "font {font-size:8pt; font-family:verdana;}";
      _newConttent += "DIV.pageClass";
      _newConttent += "{";
      _newConttent += "margin-left: auto;";
      _newConttent += "margin-right: auto;border: 1px ridge #000000;";
      _newConttent +=
        "font-family: 'Segoe UI', Tahoma, Arial, Helvetica, sans-serif;font-size: .813em;";
      _newConttent += "color: #222;background-color: #fff;";
      _newConttent += "}";
      _newConttent += "TABLE.BoxDesign TR";
      _newConttent += "{";
      _newConttent += "height: 21px;";
      _newConttent += "}";
      _newConttent += "TABLE.BoxDesign TD";
      _newConttent += "{";
      _newConttent += "BORDER-RIGHT: gray 1px solid;";
      _newConttent += "BORDER-BOTTOM: gray 1px solid;";
      _newConttent += "padding-left: 5px;";
      _newConttent += "overflow-wrap: anywhere;";
      // _newConttent+='border-color: gainsboro !important;';
      _newConttent += "}";
      _newConttent += "TABLE.BoxDesign";
      _newConttent += "{";
      _newConttent += "BORDER-TOP: gray 1px solid;";
      _newConttent += "BORDER-LEFT: gray 1px solid;";
      // _newConttent+='border-color: gainsboro !important;';
      _newConttent += "}";
      _newConttent += "P.Page_Break";
      _newConttent += "{";
      _newConttent += "PAGE-BREAK-BEFORE: always;";
      _newConttent += "border-color: gray !important;";
      _newConttent += "}";
      _newConttent += "</STYLE>";
      _newConttent += document.getElementById("divTicketPrinting").innerHTML;
      _newConttent += "</body>";
      _newConttent += "</html>";

      this.windowPreview.document.write(_newConttent);
    },
    setToDate() {
      var Days = parseInt(this.bookingDays) - 1;
      this.bookingToDate = this.bookingFromDate.addDays(Days);
    },
    GetSetupData() {
      const _data_ = {};
      MasterJS.getSetupData().then(
        response => {
          // this.SetupData = response.data;
          this.isPromoCodeRequired = response.data[0][19];
          this.isVisitorDataRequired = response.data[0][11];
          this.isOnlinePaymentReq = response.data[0][8];
          this.fillUserData();
        },
        error => {}
      );
    },
    tabNaming(TabID) {
      let self = this;
      self.bookingStages.forEach(function(element, index) {
        if (TabID == element.stageSerialNo) {
          self.currentTabName = element.stageName;
        }
      });
    },
    generateCaptcha() {
      this.captchaValue = "";
      this.captchaKey = "";
      const _data_ = { width: 100, height: 30 };
      LoginJs.GenerateCaptcha(_data_).then(
        response => {
          $("#imgCaptcha").attr("src", response.data.result1);
          this.captchaKey = response.data.result;
        },
        error => {
          if (error.response.data.message != undefined) {
            alert(
              error.response.data.message +
                "\n" +
                error.response.data.exceptionMessage
            );
          } else {
            alert("Error: " + error.response.data);
          }
        },
        failure => {
          alert("Failure: " + failure.response);
        }
      );
    },
    fillUserData() {
      LoginJs.GetCurrentUser().then(
        response => {
          if (response.data) {
            this.userTypeID = response.data.userTypeID;
            //console.log(this.userTypeID);
            this.getGenralMaster();
          }
        },
        error => {}
      );
    },
    changeFilters(filterType) {
      this.rbFilterQuota = filterType;
      // if (filterType == 1) {
      //   this.isQuotaUsed = 0;
      // } else {
      //   this.isQuotaUsed = 1;
      // }
      // this.getSavedBookingData(this.bookingID);
    },
    redirectToTransReq() {
      this.seatLeftForSlot = 0;
      if (this.captchaValue == "") {
        this.generateCaptcha();
        MessageBox.show({
          message: "Please type captcha, than click on Pay Now",
          type: "error",
          title: "Error"
        });
        return false;
      }
      const CaptchaData = {
        captchaValue: biometricJS.encryptAES(this.captchaValue),
        captchaKey: biometricJS.encryptAES(this.captchaKey)
      };
      bookingAPI.checkTransRequestCaptcha(CaptchaData).then(result => {
        if (result.data.isSuccess) {
          var type = 1;
          if (this.rbFilterQuota == 1) {
            type = 2;
          }
          bookingAPI
            .getSeatLeft({
              bookingID: this.bookingID,
              slotID: this.timeSlotID,
              bookingTypeID: this.bookingTypeID,
              type: type
            })
            .then(
              result => {
                if (result.data != "0") {
                  if (this.bookingID != -1) {
                    this.$root.$data.BookingID = this.bookingID;
                    this.$router.push({ name: "TransRequest" });
                  }
                }
              },
              error => {}
            );
        } else {
          this.generateCaptcha();
          MessageBox.show({
            message: result.data.msg,
            type: "error",
            title: "Error"
          });
        }
      });
    },
    responseFromPayment(BookingID, isSuccess, isRefund) {
      let self = this;

      // console.log(BookingID);
      var PayBooking = this.myBooking_List.filter(r => {
        return r.bookingID == BookingID;
      });
      // console.log(PayBooking);
      self.getMyBookingOnClick(PayBooking[0]);
      self.tabID = 4;
      self.tabNaming(self.tabID);
      self.isFirstTimeBookingSaved = 1;
      if (isSuccess != null && isSuccess) {
        this.getSavedBookingData(BookingID);
        this.getBookingStages(self.tabID);
      } else if (isRefund == null && !isSuccess) {
        MessageBox.show({
          message: "Payment failed, Please retry for payment.",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (isRefund) {
        MessageBox.show({
          message:
            "Ticket has been Cancelled and Refund has been Initiated. The refund amount will be credited within 4 to 7 working days after the refund is initiate into the original payment mode that was used for booking the ticket. In case of any issue, the tourists are requested to send an e-mail with the Ticket No, Name and Mobile No. through which ticket was booked on bro-rtg[at]nic[dot]in",
          type: "success",
          title: "Success"
        });
        this.$root.$data.isRefund = null;
        return;
      } else if (!isRefund) {
        MessageBox.show({
          message:
            "Ticket Cancellation failed. Please try again later. In case of any issue, the tourists are requested to send an e-mail with the Ticket No, Name and Mobile No. through which ticket was booked on bro-rtg[at]nic[dot]in",
          type: "error",
          title: "Error"
        });
        this.$root.$data.isRefund = null;
        return;
      }
    }
  },
  updated() {
    this.$nextTick(function() {
      let ekkGridList = document.querySelectorAll(".ekkGrid");
      for (let i = 0; i < ekkGridList.length; i++) {
        let GridContent = ekkGridList[i].querySelector(".GridContent");
        if (GridContent && GridContent.innerHTML) {
          let HeaderFooterRows = ekkGridList[i].querySelectorAll(".GridHeader");
          let w = GridContent.offsetWidth - GridContent.clientWidth;
          for (let j = 0; j < HeaderFooterRows.length; j++) {
            HeaderFooterRows[j].style.marginRight = w + "px";
          }
        }
      }
    });
  },
  computed: {
    calcAgeGroupList() {
      let self = this;
      var _lst = [];
      self.totalPerson = 0;
      self.totalAmount = 0;
      if (this.personAgeGroup_List.length > 0) {
        this.personAgeGroup_List.forEach(element => {
          if (element.noOfIndividuals != "") {
            element.totalAmount =
              element.amountInRs * Math.ceil(parseInt(element.noOfIndividuals));
          } else {
            element.totalAmount = "0";
          }
          self.totalPerson =
            parseInt(self.totalPerson) +
            parseInt(
              element.noOfIndividuals == "" ? "0" : element.noOfIndividuals
            );
          self.totalAmount =
            parseInt(self.totalAmount) +
            parseInt(element.totalAmount == "" ? "0" : element.totalAmount);
        });
        _lst = this.personAgeGroup_List;
        if (this.taxRates_List.length == 0) {
          this.totalCGST = 0;
          this.totalSGST = 0;
          this.otherTaxs = 0;
          this.finalTotalAmount =
            parseFloat("0" + this.totalAmount) +
            parseFloat("0" + this.totalCGST) +
            parseFloat("0" + this.totalSGST) +
            parseFloat("0" + this.otherTaxs) -
            parseFloat("0" + this.discountAmount);

          if (this.finalTotalAmount < 0) {
            this.finalTotalAmount = 0;
          }
        }
        // if(this.totalAmount>0){
        //     this.totalCGST = 0;
        //     this.totalSGST = 0;
        //     this.otherTaxs = 0;
        //     this.promoCode = "";
        //     this.discountAmount = 0;

        //     this.finalTotalAmount=parseFloat("0"+this.totalAmount) +
        //     parseFloat("0"+this.totalCGST) + parseFloat("0"+this.totalSGST)
        //     + parseFloat("0"+this.otherTaxs) - parseFloat("0"+this.discountAmount) ;
        // }
        // else{
        //     this.totalCGST = 0;
        //     this.totalSGST = 0;
        //     this.otherTaxs = 0;
        //     this.promoCode = "";
        //     this.discountAmount = 0;
        //     this.finalTotalAmount = 0;
        // }
      }
      return _lst;
    },
    calcTaxRate() {
      let self = this;
      var _lst = this.taxRates_List;
      if (this.taxRates_List.length > 0) {
        if (this.totalAmount > 0) {
          this.taxRates_List.forEach(element => {
            if (element.taxID != 3) {
              element.taxAmount = Math.round(
                parseFloat(self.totalAmount) * parseFloat(element.taxRate / 100)
              );
            }
            if (element.taxID == 1) {
              self.totalCGST = element.taxAmount;
            }
            if (element.taxID == 2) {
              self.totalSGST = element.taxAmount;
            }
            if (element.taxID == 3) {
              self.otherTaxs = element.taxAmount;
            }
          });
          //this.totalSGST = 0;
          //this.otherTaxs = 0;
          //this.promoCode = "";
          //this.discountAmount = 0;

          this.finalTotalAmount =
            parseFloat("0" + this.totalAmount) +
            parseFloat("0" + this.totalCGST) +
            parseFloat("0" + this.totalSGST) +
            parseFloat("0" + this.otherTaxs) -
            parseFloat("0" + this.discountAmount);

          if (this.finalTotalAmount < 0) {
            this.finalTotalAmount = 0;
          }
        } else {
          this.totalCGST = 0;
          this.totalSGST = 0;
          this.otherTaxs = 0;
          this.promoCode = "";
          this.discountAmount = 0;
          this.finalTotalAmount = 0;
        }
      } else {
        this.totalCGST = 0;
        this.totalSGST = 0;
        this.otherTaxs = 0;
        this.promoCode = "";
        this.discountAmount = 0;
        this.finalTotalAmount = 0;
      }
      return _lst;
    }
  },
  created() {
    let self = this;
    this.shortcutKeys = function(e) {
      if (e.key == "ArrowLeft") {
        if (self.candIndex > 0) {
          e.preventDefault();
          e.stopPropagation();
          //self.PrevCandidate();
        }
      }
      if (e.key == "ArrowRight") {
        if (self.candIndex + 1 < self.cand_List.length) {
          e.preventDefault();
          e.stopPropagation();
          //self.NextCandidate();
        }
      }
    };
    document.addEventListener("keydown", this.shortcutKeys, true);
  },
  beforeDestroy() {
    this.shortcutKeys = null;
    document.removeEventListener("keydown", this.shortcutKeys, true);
  },
  mounted() {
    ekkJS.setDateControls();
    this.GetSetupData();
    //this.getPersonAgeGroup();
    // this.getAvailableSlot();
    let self = this;
    if (
      self.$root.$data.BookingID != null &&
      self.$root.$data.BookingID != -1
    ) {
      this.showMyBooking(
        self.$root.$data.BookingID,
        self.$root.$data.isSuccess,
        self.$root.$data.isRefund
      );
    } else {
      this.showMyBooking();
    }
  },
  watch: {
    bookingID(newValue, oldValue) {
      this.getBookingStages();
    },
    bookingTypeID(newValue, oldValue) {
      if (this.bookingType_List.length > 0) {
        this.bookingForUnit = this.bookingType_List.filter(b => {
          return b[0] == this.bookingTypeID;
        })[0][7];
        var bookingList = this.bookingType_List.filter(b => {
          return b[0] == this.bookingTypeID;
        });
        if (bookingList[0][3] == "Days" || bookingList[0][3] == "Day") {
          this.bookingDays = bookingList[0][4];
        } else {
          this.bookingDays = 1;
        }
        //console.log(this.bookingDays);
      }
    },
    tabID(newValue, oldValue) {
      this.tabNaming(this.tabID);
      // if (this.tabID == 1) {
      //   this.currentTabName = "Booking";
      //   this.prevTabName = "";
      //   this.nextTabName = "Contact Detail";
      // }
      // if (this.tabID == 2) {
      //   this.currentTabName = "Contact Detail";
      //   this.prevTabName = "Booking";
      //   this.nextTabName = "Payment";
      // }
      // if (this.tabID == 3) {
      //   this.currentTabName = "Payment";
      //   this.prevTabName = "Contact Detail";
      //   this.nextTabName = "Genrate Ticket";
      // }
      // if (this.tabID == 4) {
      //   this.currentTabName = "Genrate Ticket";
      //   this.prevTabName = "Payment";
      //   this.nextTabName = "";
      // }
    },
    bookingDate(newValue, oldValue) {
      this.getAvailableSlot();
    },
    bookingToDate(newValue, oldValue) {
      this.getAvailableSlot();
    },
    bookingFromDate(newValue, oldValue) {
      this.setToDate();
    },
    rbFilterQuota(newValue, oldValue) {
      this.getAvailableSlot();
    }
  }
};
</script>
<style scoped>
.tblRow {
  border-bottom: solid 1px darkgray;
  padding-top: 5px;
  padding-bottom: 5px;
}

.radioSpan {
  margin-right: 3px;
  border: solid thin darkgray;
  border-radius: 5px;
  line-height: 25px;
  padding: 0px 8px;
  cursor: pointer;
  display: inline-block;
  min-width: 75px;
  /* min-height: 26px; */
  text-align: center;
  font-size: medium;
}

.radioSpan label {
  cursor: pointer;
  display: inline-block;
  width: 100%;
}

.radioSpan input[type="radio"] {
  display: none;
}

.radioSpanChecked {
  /* background-color: white; */
  /* background-color: #ffa50052; */
}

.radioSpan:hover {
  background-color: orange;
}

.IconbuttonPlus {
  padding: 0px;
}

.IconbuttonPlus a.glyphicons:before {
  font-size: 20px;
  cursor: pointer;
  display: block;
  transition: all 300ms;
  /* color: greenyellow; */
}

.IconbuttonMinus {
  padding: 0px;
}

.IconbuttonMinus a.glyphicons:before {
  font-size: 20px;
  cursor: pointer;
  display: block;
  transition: all 300ms;
  /* color: red; */
}

.appDropBox {
  font-weight: bold;
  line-height: 22px;
  height: 27px;
  border-radius: 4px;
  padding-left: 10px;
  padding-right: 10px;
}

.ticketTable {
  width: 100%;
  margin-top: 25px;
  font-size: medium;
}

.ticketTable tr {
  height: 35px;
  border-bottom: solid 1px darkgray;
}
</style>
<style scoped>
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  font-weight: bold;
}

.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}

#divApplication {
  margin-left: 4px;
  margin-right: 5px;
  border: dotted 1px darkgray;
  border-radius: 5px;
  padding: 5px 0px 0px 5px;
}

.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(200px);
  opacity: 0;
}

.fade-enter-active {
  animation: fade-in 0.4s;
}

.fade-leave-active {
  animation: fade-in 0.4s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  5% {
    opacity: 0.05;
  }

  10% {
    opacity: 0.1;
  }

  20% {
    opacity: 0.2;
  }

  25% {
    opacity: 0.25;
  }

  30% {
    opacity: 0.3;
  }

  35% {
    opacity: 0.35;
  }

  40% {
    opacity: 0.4;
  }

  45% {
    opacity: 0.45;
  }

  50% {
    opacity: 0.5;
  }

  55% {
    opacity: 0.55;
  }

  60% {
    opacity: 0.6;
  }

  65% {
    opacity: 0.65;
  }

  70% {
    opacity: 0.7;
  }

  75% {
    opacity: 0.75;
  }

  80% {
    opacity: 0.8;
  }

  85% {
    opacity: 0.85;
  }

  90% {
    opacity: 0.9;
  }

  95% {
    opacity: 0.95;
  }

  100% {
    opacity: 1;
  }
}

.tblEntryForm > .Flex_Row {
  display: flex;
  flex-wrap: wrap;
}

/* @media screen and (max-width: 4000px) {
  .visitorField {
    width: 45%;
  }
}
@media screen and (max-width: 2000px) {
  .visitorField {
    width: 100%;
  }
} */
@media screen and (max-width: 1200px) {
  .imgHeight {
    height: 75px;
  }

  .visitorField {
    width: 100%;
  }

  .btn {
    width: 40%;
  }

  .imgHeight {
    height: 100%;
  }

  .EntryBlock {
    width: 80%;
  }

  #divApplication {
    display: block;
    height: auto;
  }

  #location {
    width: 70%;
  }

  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }

  .EntryBlock {
    width: 100%;
  }

  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }

  .tblEntryForm {
    width: calc(100vw - 35px);
  }

  /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  }

  /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    /* width: 50% !important; */
  }

  /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  }

  /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }

  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }

  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .imgHeight {
    height: 55px;
  }

  .visitorField {
    width: 100%;
  }

  .btn {
    width: 100%;
  }

  .imgHeight {
    height: 60px;
  }

  .EntryBlock {
    width: calc(100vw - 35px);
  }

  .imgHeight {
    height: 60px;
  }

  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }

  #location {
    width: 70%;
  }

  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }

  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }

  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }

  .tblEntryForm .divHR {
    display: block;
  }

  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }

  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TicketBooking.vue